import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
const Hero = () => {
  return <section className="relative pt-20 overflow-hidden bg-gradient-to-br from-teal-50 via-blue-50 to-white" data-id="element-357">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden" data-id="element-358">
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-teal-200 rounded-full opacity-20 blur-3xl" data-id="element-359"></div>
        <div className="absolute top-40 -left-20 w-80 h-80 bg-blue-200 rounded-full opacity-20 blur-3xl" data-id="element-360"></div>
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-purple-200 rounded-full opacity-20 blur-3xl" data-id="element-361"></div>
        <div className="absolute bottom-20 left-1/3 w-72 h-72 bg-rose-200 rounded-full opacity-20 blur-3xl" data-id="element-362"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-20 relative z-10" data-id="element-363">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-364">
          <div className="lg:col-span-6 lg:pr-8 order-2 md:order-1" data-id="element-365">
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold text-navy-950 leading-tight mb-6" data-id="element-366">
              <span className="block mb-2" data-id="element-367">Elevate Your</span>
              <span className="block text-blue-500 relative" data-id="element-368">
                Spa Experience
                <svg className="absolute -bottom-3 left-0 w-full h-3 text-blue-200" viewBox="0 0 200 8" preserveAspectRatio="none" aria-hidden="true" data-id="element-369">
                  <path d="M0,5 C50,0 150,0 200,5" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" data-id="element-370"></path>
                </svg>
              </span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-lg" data-id="element-371">
              Delight your guests with premium, wellness-focused beverages that
              enhance their spa journey and increase their lifetime value.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8" data-id="element-372">
              <div className="flex items-center bg-white/80 backdrop-blur-sm p-3 rounded-lg shadow-sm transform hover:scale-105 transition duration-300" data-id="element-373">
                <CheckCircleIcon className="h-5 w-5 text-blue-500 mr-2 flex-shrink-0" data-id="element-374" />
                <span className="text-gray-700" data-id="element-375">
                  29 Wellness-Infused Flavors
                </span>
              </div>
              <div className="flex items-center bg-white/80 backdrop-blur-sm p-3 rounded-lg shadow-sm transform hover:scale-105 transition duration-300" data-id="element-376">
                <CheckCircleIcon className="h-5 w-5 text-blue-500 mr-2 flex-shrink-0" data-id="element-377" />
                <span className="text-gray-700" data-id="element-378">Enhance Guest Experience</span>
              </div>
              <div className="flex items-center bg-white/80 backdrop-blur-sm p-3 rounded-lg shadow-sm transform hover:scale-105 transition duration-300" data-id="element-379">
                <CheckCircleIcon className="h-5 w-5 text-blue-500 mr-2 flex-shrink-0" data-id="element-380" />
                <span className="text-gray-700" data-id="element-381">
                  Reduce Guest Churn by 15%+
                </span>
              </div>
              <div className="flex items-center bg-white/80 backdrop-blur-sm p-3 rounded-lg shadow-sm transform hover:scale-105 transition duration-300" data-id="element-382">
                <CheckCircleIcon className="h-5 w-5 text-blue-500 mr-2 flex-shrink-0" data-id="element-383" />
                <span className="text-gray-700" data-id="element-384">
                  Eco-Friendly & Sustainable
                </span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-385">
              <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-lg text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all transform hover:scale-105 hover:shadow-xl" aria-label="Book a free SmartSoda demo for your spa" data-id="element-386">
                Book a Free Demo
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-387" />
              </a>
              <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-gray-300 text-base font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all transform hover:scale-105 hover:shadow-md" aria-label="Get a SmartSoda quote in 24 hours for your spa" data-id="element-388">
                Get a Quote in 24h
              </a>
            </div>
          </div>
          <div className="lg:col-span-6 relative order-1 md:order-2" data-id="element-389">
            <div className="relative" data-id="element-390">
              {/* Main image with spa environment */}
              <div className="bg-white p-3 rounded-3xl shadow-2xl relative z-10 transform hover:scale-[1.02] transition-transform duration-500 overflow-hidden" data-id="element-391">
                <div className="rounded-2xl overflow-hidden" data-id="element-392">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iX3QNp2ei22jN6MEsgLhjB/Medispa_5.webp" alt="Luxury spa guest in white robe enjoying a SmartSoda beverage at an elegant marble reception counter with a SmartSoda machine, infused water, and spa amenities" className="w-full object-cover" width="600" height="400" fetchpriority="high" loading="eager" decoding="async" data-id="element-393" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add animation keyframes */}
      <style jsx data-id="element-394">{`
        @keyframes progress {
          0% {
            width: 0%;
          }
          100% {
            width: 90%;
          }
        }
      `}</style>
    </section>;
};
export default Hero;